import {Component, OnInit} from '@angular/core';
import {CrisisAlertService} from '../../services/crisis-alert.service';

@Component({
  selector: 'app-export',
  templateUrl: './export.component.html',
  styleUrls: ['./export.component.scss']
})
export class ExportComponent implements OnInit {

  constructor(private crisisAlertService: CrisisAlertService) {
  }

  ngOnInit() {
    this.crisisAlertService.ensureRefData();
  }

}
